import { n$2, t$2, e$2, i$1, r$1 } from '@/js/global/global'
import { AnimateProductItem } from '@/js/global/animations'
import { cart } from '@/js/global/cart'

const selectors$K = {
  item: ".product-item",
  itemInner: ".product-item__inner",
  quickViewButton: ".show-product-quickview",
  addToCart: "[data-add-to-cart]",
  quickCart: ".quick-cart",
  purchaseConfirmation: ".purchase-confirmation-popup",
  link: ".fs-product-card-title a",
};

function ProductItem(container) {
  const items = t$2(selectors$K.item, container);

  if (!items.length) return;

  // Add z-index for quick-buy overlap
  items.forEach((item, i) => {
    item.style.setProperty("--z-index-item", items.length - i)
    item.addEventListener('click', (event) => {
      if (!event.target || (event.target.tagName !== 'A' && event.target.tagName !== 'BUTTON')) {
        const href = item.querySelector(selectors$K.link).getAttribute('href');
        if (href) window.location.href = href;
      }
    })
  });

  const productItemAnimations = AnimateProductItem(items);
  const quickViewButtons = t$2(selectors$K.quickViewButton, container);
  const addToCartButtons = t$2(selectors$K.addToCart, container);
  const purchaseConfirmation = n$2(selectors$K.purchaseConfirmation, document);
  const quickCart = n$2(selectors$K.quickCart, document);

  const events = [
    e$2(quickViewButtons, "click", e => {
      e.preventDefault();
      e.stopPropagation();

      const linkEl = e.currentTarget;
      const url = linkEl.getAttribute("data-href");

      r$1("quick-view:open", null, {
        productUrl: url,
        trigger: e.currentTarget,
      });
    }),

    e$2(addToCartButtons, "click", e => {

      e.preventDefault();
      e.stopPropagation();

      const productForm = e.currentTarget.closest('form');
      const button = e.currentTarget;

      const {
        currentProductId
      } = productForm.dataset;

      if (!currentProductId) return;
      cart.addItemById(currentProductId, 1).then(_ref => {
        let {
          res
        } = _ref;
        i$1(button, "loading");
        if (purchaseConfirmation && !quickCart) {
          r$1("confirmation-popup:open", null, {
            product: res.items[0]
          });
        } else {
          r$1("quick-cart:updated");
          // Need a delay to allow quick-cart to refresh
          setTimeout(() => {
            r$1("quick-cart:open");
          }, 300);
        }
      });
    })
  ];

  const unload = () => {
    productItemAnimations.destroy();
    events.forEach(unsubscribe => unsubscribe());
  };

  return {
    unload
  };
}

export { ProductItem }